import React, { useEffect, useState } from "react";
import logo from "../../utils/images/logo.svg";
import { useNavigate } from "react-router-dom";
import Button from 'react-bootstrap/Button';
import { Modal } from "react-bootstrap";
import { signInAction } from "../../_actions";
import { useDispatch, useSelector } from "react-redux";
import { status } from "../../_constants/commonIVY";


function Signin() {
    const navigate = useNavigate();
    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);
    const [showPassword, setShowPassword] = useState(false);
    const dispatch = useDispatch();
    const SignInData = useSelector((state) => state.signIn);

    const [credentials, setCredentials] = useState({
        email: "demo@ivy.com",
        password: "12345678"
    })

    const handleSignOut = () => {
        // localStorage.removeItem("User");
        // localStorage.setItem("isLogin", JSON.stringify(false));
        // navigate("/signin");
        handleClose(true);
    };

    // useEffect(() => {
    //     if (SignInData?.signIn_status === status.SUCCESS) {
    // localStorage.setItem("User", JSON.stringify(SignInData.signIn_data))
    // localStorage.setItem("isLogin", JSON.stringify(true));
    //         navigate("/dashboard");
    //     }
    // }, [SignInData.signIn_data]);


    const handleSubmit = (e) => {
        e.preventDefault();
        dispatch(signInAction.createSignIn(credentials))
        navigate("/dashboard")
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setCredentials((preData) => ({
            ...preData,
            [name]: value,
        }));
    };

    return (
        <>
            <div className="main-wrapper">
                <div className="login-section">
                    <div className="container">
                        <div className="logo-img">
                            <img src={logo} alt="logo" />
                        </div>
                        <div className="login-sec">
                            <div className="login-title">
                                <h1>Sign In</h1>
                            </div>
                            <div className="login-group">
                                <form>
                                    <div className="form-group">
                                        <div className="email-icon" />
                                        <input
                                            type="email"
                                            name="email"
                                            className="form-control"
                                            id="exampleInputEmail1"
                                            aria-describedby="emailHelp"
                                            placeholder="Email"
                                            onChange={handleChange}
                                            value={credentials.email}
                                        />
                                        {/* {errors.email && <div className="error" style={{ color: "red" }}>{errors.email}
                                        </div>} */}
                                    </div>

                                    <div className="form-group">
                                        <div className="password-icon" />
                                        <input
                                            type={showPassword ? "text" : "password"}
                                            name="password"
                                            value={credentials.password}
                                            placeholder="Password"
                                            className="form-control"
                                            onChange={handleChange}
                                        />
                                        <div
                                            className="cursor-pointer"
                                            onClick={() => setShowPassword((prev) => !prev)}
                                        >
                                            {showPassword ? (
                                                <div className="eye-on" />
                                            ) : (
                                                <div className="eye-off" />
                                            )}
                                        </div>
                                    </div>

                                    <div className="form-check">
                                        <input
                                            type="checkbox"
                                            className="form-check-input"
                                            id="keepSignedIn"
                                        />
                                        <label className="form-check-label" htmlFor="keepSignedIn">
                                            Keep me signed in
                                        </label>
                                    </div>

                                    <button type="submit" className="btn btn-primary" onClick={handleSubmit}>
                                        Log In
                                    </button>
                                    <p className="text-center">
                                        Don’t have an account?
                                        <button >
                                            Sign Up
                                        </button>
                                    </p>
                                    <div className="or-divider">
                                        <div className="line"></div>
                                        <span className="or-text">OR</span>
                                        <div className="line"></div>
                                    </div>
                                    <button className="microsoft-btn transition">
                                        <img
                                            src="https://upload.wikimedia.org/wikipedia/commons/4/44/Microsoft_logo.svg"
                                            alt="Microsoft"
                                            className="image-microsoft"
                                        />
                                        <span className="font-semibold">Sign in with Microsoft</span>
                                    </button>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Modal
                className="signout-modal"
                show={show} onHide={handleClose} animation={false}
            >
                <div className="d-flex justify-content-end pe-3 pt-3">
                    <button type="button" className="btn-close" onClick={handleClose}></button>
                </div>
                <Modal.Header className="border-0 justify-content-center pt-0 pb-0">
                    <Modal.Title className="text-success text-center">
                        Sign Out
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body className="text-center">
                    <p>Are you sure you want to sign out?</p>
                    <Button
                        variant="success"
                        className="w-100 mb-2 active:scale-95 active:brightness-90 transition"
                        onClick={handleSignOut}
                    >
                        Sign Out
                    </Button>
                    <Button
                        variant="outline-success"
                        className="w-100 active:scale-95 transition"
                        onClick={handleClose}
                    >
                        Cancel
                    </Button>
                </Modal.Body>
            </Modal>
        </>
    );
}

export default Signin;